import { FC } from 'react';
import { Flex } from '@chakra-ui/react';

import ErrorView from 'components/ErrorView';
import { useNewInsuranceCoverage } from 'features/Insurance/hooks/useNewInsuranceCoverage';
import logger from 'helpers/logger';

import PageWrapper from '../../../components/PageWrapper';
import CompleteGuaranteesList from '../../../components/PageWrapper/components/CompleteGuaranteesList';
import Timeline from '../../../components/PageWrapper/components/InsuranceTimeline';
import offers from '../../../offers';
import * as routes from '../../../routes';
import { AssuredBy, isSelectedProviderPlanId } from '../../../types';
import cover from '../assets/computerBreakageCover.png';
import locales from './locales';

const OFFER_NAME = 'Computer Breakage';
const PAGE_NAME = `Insurance${OFFER_NAME.replaceAll(' ', '')}OfferDetails Viewed`;

const ComputerBreakage: FC = () => {
  const { coverage, planId, routeState } = useNewInsuranceCoverage();

  if (!isSelectedProviderPlanId(planId)) {
    logger.error(
      `[Insurances feature]: PlanId is not correct, should be "basic", "plus", "pro" or "business", got ${planId} instead`,
    );
    return <ErrorView />;
  }

  const { isCovered, isCoveredFromPlan } = coverage.computerBreakage;

  const guarantees = locales.content;

  return (
    <PageWrapper
      assuredBy={AssuredBy.Shine}
      backButtonLink={routes.coverage}
      coverImage={cover}
      from={routeState.from}
      intercomMessage={locales.claimButton.intercomMessage}
      isCovered={isCovered}
      isCoveredFromPlan={isCoveredFromPlan}
      offer={offers.computerBreakage}
      offerName={OFFER_NAME}
      pageName={PAGE_NAME}
      similarOffers={[
        offers.mobileScreen,
        offers.hospitalization,
        offers.purchaseProtection,
      ]}
    >
      <Flex direction="column" gap="space-40">
        <CompleteGuaranteesList guarantees={guarantees} />
        <Timeline
          steps={locales.content.timeline.items}
          title={locales.content.timeline.title}
        />
      </Flex>
    </PageWrapper>
  );
};

export default ComputerBreakage;
